import { render, staticRenderFns } from "./CouponCard.vue?vue&type=template&id=924e1630&scoped=true"
import script from "./CouponCard.vue?vue&type=script&lang=js"
export * from "./CouponCard.vue?vue&type=script&lang=js"
import style0 from "./CouponCard.vue?vue&type=style&index=0&id=924e1630&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924e1630",
  null
  
)

export default component.exports